export default {
  init() {
    // JavaScript to be fired on all pages
    //var $module_faq = $('.faq-item');
    var $faq_trigger = $('.faq-question');
    //var $faq_content = $('.faq-answer');

    if( $('div').hasClass( 'module-faq' ) ) {
      $faq_trigger.click(function(){
        $(this).parent().toggleClass( 'is-open' );
        $(this).siblings('.faq-answer').slideToggle();
      });
    }

    $('.search-bar').click(function(){
      $(this).addClass('is-open');
    });

    $('.menu-item-has-children').prepend('<span class="child-trigger"></span>');

    $('.mobile-trigger').click(function(){
      $('.banner').addClass('mobile-open');
    });

    $('.mobile-close').click(function(){
      $('.banner').removeClass('mobile-open');
    });

    $('.child-trigger').click(function(){
      $(this).siblings('.sub-menu').toggle();
    });

    $('.cta-close').click(function(){
      $('.shipping--cta-bar').hide();
      //var date = new Date();
      //date.setTime(date.getTime() + (24 * 1000));
      $.cookie('closed', 'is_close', { expires: 1, path: '/' });
    });

    if (!$.cookie('closed')) {
     // no cookie
     $('.shipping--cta-bar').slideDown();
    }

    $(window).scroll(function(){
      if( scrollY > 43 ){
        $('body').addClass('is-fixed');
      } else {
        $('body').removeClass('is-fixed');
      }
    });

    if( $('div').hasClass( 'module-supplier' ) ) {
      $('.supplier-logos').slick({
        arrows: true,
        infinite: true,
        variableWidth: false,
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [{
          breakpoint: 990,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },

        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },

        {
          breakpoint: 665,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
          },
        }],
      });
    }

    if( $('section').hasClass('widget') ) {
      $('.widget h3').append('<i class="icon icon--widget"></i>');

      $('.widget h3').click(function(){
        $(this).toggleClass('active');
        $(this).next().toggleClass('closed');
      });
    }

    $('.mobile-filter').click(function(){
      $('.sidebar-woocommerce').toggleClass('is-open');
    });

    // if( document.getElementById( 'wc_checkout_add_ons' ) ){
    //   alert("S");
    //   $('.wc_checkout_add_ons textarea').attr( 'placeholder', 'Your message (max 120 characters)' );
    // }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js